import React from "react";
import { connect } from "react-redux";
import queryString from "query-string";
import { Col, Container, FormGroup, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import { PathwayCard, PathwayCardBody, PathwayCardHeader } from "../../../_UI/Components/PathwayCard";
import { PathwayInput as Input } from "../../../_UI/StyledComponents/PathwayForm";
import classnames from "classnames";
import AlertComponent from "../../../_UI/Components/Alerts/AlertComponent";
import RegistrationComponent from "../../_components/RegistrationComponent";
import { autologinShopifyWithNounce, registerWithAuthData } from "../../../user/services/store/user.actions";
import {
    addConnectedAuthDataId,
    getClientsForSelectedOrganization,
} from "../../../organization/client/services/clients.actions";
import { login } from "../../../user/services/store/authentication.actions";
import LoadingSpinner from "../../../_UI/Components/LoadingSpinner";
import LoginFormV2 from "../../../_components/LoginFormV2";

class StripeConnectLoginScreen extends React.Component {
    constructor(props) {
        super(props);

        // reset login status
        //this.props.dispatch(userActions.logout());

        let params = queryString.parse(this.props.location.search);
        this.state = {
            activeTab: "1",
            autoLogin: params["autologin"],
            urlParams: params,
        };

        this.toggle = this.toggle.bind(this);
        this.linkAuthData = this.linkAuthData.bind(this);

        this.register = this.register.bind(this);
    }

    linkAuthData() {
        if (this.state.createNewClient) {
            this.props.dispatch(addConnectedAuthDataId(null, this.state.urlParams.connectedAuthDataExternalUUID));
        } else {
            let selectInput = document.getElementById("clientSelection");
            this.props.dispatch(
                addConnectedAuthDataId(selectInput.value, this.state.urlParams.connectedAuthDataExternalUUID)
            );
        }
    }

    componentWillMount() {
        const { dispatch } = this.props;
        if (this.state.autoLogin) {
            // TODO: Change dispatch
            dispatch(
                autologinShopifyWithNounce(
                    this.state.urlParams.shop,
                    this.state.urlParams.nounce,
                    this.state.urlParams.hmac
                )
            ).then(() => {
                this.setState({
                    autoLogin: false,
                    activeTab: "2",
                });
            });
        } else {
            this.setState({
                autoLogin: false,
            });
        }
    }

    componentDidMount() {
        if (
            this.props.authentication &&
            this.props.authentication.loggedIn &&
            this.props.authentication.user &&
            this.props.authentication.user.selectedOrganization
        ) {
            this.props.dispatch(getClientsForSelectedOrganization());
        }
    }

    register(e, email, password, password2, acceptTos, acceptDpa) {
        e.preventDefault();
        this.setState({ submitted: true });
        const { dispatch } = this.props;
        let authData = {
            email: email,
            password: password,
            passwordRepeat: password2,
            connectedAuthDataExternalUUID: this.state.urlParams.connectedAuthDataExternalUUID,
            acceptTos: acceptTos,
            acceptDpa: acceptDpa,
        };

        dispatch(registerWithAuthData(authData)).then(() => {
            if (this.props.userRegistration.success) {
                dispatch(login(authData.email, authData.password, null, true));
            }
        });
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
            });
        }
    }

    render() {
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <Col xs="12" className="justify-content-center">
                            <img src="logo.png" width="300px" alt="Pathway Logo" className="rounded mx-auto d-block" />
                            <br />
                            <br />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="2" />
                        <Col xs="8" className="justify-content-center">
                            <AlertComponent
                                errorMessages={this.props.userRegistration.errorMessage}
                                warningMessages={this.props.userRegistration.warningMessage}
                            />
                        </Col>
                        <Col xs="2" />
                    </Row>
                    {this.state.urlParams && (!this.state.urlParams.shop || !this.state.urlParams.nounce) && (
                        <Row>
                            <Col>
                                <h3>Anmeldung nicht möglich</h3>
                                Bei der Registrierung ihres Shops trat ein Fehler auf. <br />
                                Bitte installiere die App erneut.
                            </Col>
                        </Row>
                    )}
                    {this.state.urlParams && this.state.autoLogin && (
                        <LoadingSpinner loading={this.state.autoLogin} size="4rem" />
                    )}

                    {this.state.urlParams &&
                        this.state.urlParams.shop &&
                        this.state.urlParams.nounce &&
                        !this.state.autoLogin && (
                            <Row>
                                <Col xs="2" />
                                <Col md="8">
                                    {this.props.authentication &&
                                    this.props.authentication.loggedIn &&
                                    this.props.authentication.user &&
                                    this.props.authentication.user.selectedOrganization ? (
                                        <div>
                                            <PathwayCard>
                                                <PathwayCardBody>
                                                    <Row style={{ marginBottom: "15px" }}>
                                                        <Col xs="2"></Col>
                                                        <Col xs="8">
                                                            <h3>Firma auswählen</h3>
                                                        </Col>
                                                        <Col xs="2"></Col>
                                                    </Row>
                                                    <Row style={{ marginBottom: "15px" }}>
                                                        <Col xs="2"></Col>
                                                        <Col xs="8">
                                                            {!this.state.createNewClient && (
                                                                <Input
                                                                    type="select"
                                                                    id="clientSelection"
                                                                    name="clientSelection"
                                                                >
                                                                    {this.props.client &&
                                                                        this.props.client.clients &&
                                                                        this.props.client.clients.length > 0 &&
                                                                        this.props.client.clients.map((item, index) => {
                                                                            return (
                                                                                <option
                                                                                    key={index}
                                                                                    value={item.externalUUID}
                                                                                >
                                                                                    {item.name}
                                                                                </option>
                                                                            );
                                                                        })}
                                                                </Input>
                                                            )}
                                                        </Col>
                                                        <Col xs="2"></Col>
                                                    </Row>
                                                    <Row style={{ marginBottom: "15px" }}>
                                                        <Col xs="2"></Col>
                                                        <Col xs="4">
                                                            <Label
                                                                style={{ display: "inline-block" }}
                                                                for="createNewClientCheckbox"
                                                            >
                                                                Neue Firma erstellen
                                                            </Label>
                                                        </Col>
                                                        <Col xs="3">
                                                            <Input
                                                                style={{ display: "inline-block" }}
                                                                type="checkbox"
                                                                id="createNewClientCheckbox"
                                                                name="createNewClientCheckbox"
                                                                value={this.state.createNewClient}
                                                                onChange={(e) =>
                                                                    this.setState({
                                                                        createNewClient: e.target.checked,
                                                                    })
                                                                }
                                                            />
                                                        </Col>
                                                        <Col xs="2"></Col>
                                                    </Row>
                                                    <FormGroup>
                                                        <Row style={{ marginBottom: "15px" }}>
                                                            <Col xs="2">
                                                                <LoadingSpinner
                                                                    loading={this.props.client.subloading}
                                                                />
                                                            </Col>
                                                            <Col xs="8">
                                                                <button
                                                                    className="btn btn-md btn-primary"
                                                                    onClick={this.linkAuthData}
                                                                >
                                                                    Mit Firma verbinden
                                                                </button>
                                                            </Col>
                                                            <Col xs="2"></Col>
                                                        </Row>
                                                    </FormGroup>
                                                </PathwayCardBody>
                                            </PathwayCard>
                                        </div>
                                    ) : (
                                        <div>
                                            <Nav tabs>
                                                <NavItem>
                                                    <NavLink
                                                        active={this.state.activeTab === "1"}
                                                        className={classnames({
                                                            activated: this.state.activeTab === "1",
                                                        })}
                                                        onClick={() => {
                                                            this.toggle("1");
                                                        }}
                                                    >
                                                        Registrierung
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink
                                                        active={this.state.activeTab === "2"}
                                                        className={classnames({
                                                            activated: this.state.activeTab === "2",
                                                        })}
                                                        onClick={() => {
                                                            this.toggle("2");
                                                        }}
                                                    >
                                                        Login
                                                    </NavLink>
                                                </NavItem>
                                            </Nav>
                                            <TabContent activeTab={this.state.activeTab}>
                                                <TabPane tabIndex="1" tabId="1">
                                                    <Row>
                                                        <Col>
                                                            <h1>Registrierung</h1>
                                                            <p className="text-muted">Nur noch ein Schritt</p>
                                                            <RegistrationComponent
                                                                register={this.register}
                                                                registration={this.props.userRegistration}
                                                                loading={this.props.userRegistration.registering}
                                                                loginIdentifier="stripe"
                                                            />
                                                        </Col>
                                                    </Row>
                                                </TabPane>
                                                <TabPane tabIndex="2" tabId="2">
                                                    <Row>
                                                        <Col>
                                                            <h1>Login</h1>
                                                            <p className="text-muted">
                                                                Bitte melde Dich mit Deiner E-Mail Adresse an
                                                            </p>
                                                            <LoginFormV2
                                                                loginIdentifier="stripe"
                                                                loginCallback={() =>
                                                                    this.props.dispatch(
                                                                        getClientsForSelectedOrganization()
                                                                    )
                                                                }
                                                            />
                                                        </Col>
                                                    </Row>
                                                </TabPane>
                                            </TabContent>
                                        </div>
                                    )}
                                </Col>
                                <Col xs="2" />
                            </Row>
                        )}
                </Container>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { loggingIn, authentication, client, userRegistration } = state;

    return {
        loggingIn,
        authentication,
        client,
        userRegistration,
    };
}

export default connect(mapStateToProps)(StripeConnectLoginScreen);
